"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RxDatabase = exports.createRxCollection = void 0;
var collection_hooks_1 = require("./collection-hooks");
Object.defineProperty(exports, "createRxCollection", { enumerable: true, get: function () { return collection_hooks_1.createRxCollection; } });
var database_prototype_1 = require("./database-prototype");
Object.defineProperty(exports, "RxDatabase", { enumerable: true, get: function () { return database_prototype_1.RxDatabase; } });
//# sourceMappingURL=index.js.map